import { ContractTypeEnum } from "@src/__generated__/urql-graphql";
import type { MediaModel } from "@src/utils/components/dropzone";
import { now, toApiDate } from "@src/utils/dates";
import { required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";
import { compact } from "lodash";

export class FormContract {
  title = new FieldState("").validators(required);
  valid_from = new FieldState<Date>(now()).validators(required);
  valid_to = new FieldState<Date | undefined>(now()).validators();
  type = new FieldState<string>(ContractTypeEnum.MasterAgreement).validators(
    required,
  );
  valid_to_indefinite = new FieldState(false).validators();
  files = new FieldState<MediaModel[]>([]).validators();
  project_ids = new FieldState<string[]>([]).validators();
  related_to = new FieldState("").validators(required);
  client_id = new FieldState("").validators();
  brand_id = new FieldState("").validators();
  contractor_id = new FieldState("").validators();

  form = new FormState({
    title: this.title,
    valid_from: this.valid_from,
    valid_to: this.valid_to,
    type: this.type,
    files: this.files,
    related_to: this.related_to,
    project_ids: this.project_ids,
    client_id: this.client_id,
    valid_to_indefinite: this.valid_to_indefinite,
    brand_id: this.brand_id,
    contractor_id: this.contractor_id,
  });

  validate = async () => {
    const res = await this.form.validate();

    return res.hasError ? null : this.serialize();
  };

  serialize() {
    return {
      title: this.title.$,
      valid_from: toApiDate(this.valid_from.$),
      valid_to: this.valid_to.$ ? toApiDate(this.valid_to.$) : undefined,
      valid_to_indefinite: this.valid_to_indefinite.$,
      type: this.type.$ as ContractTypeEnum,
      files: compact(this.files.$.map((f) => f.isFile && f._file)),
      project_ids: this.project_ids.$,
      client_id: this.client_id.$ || undefined,
      brand_id: this.brand_id.$ || undefined,
      contractor_id: this.contractor_id.$ || undefined,
    };
  }
}

export type IFormContractSerialized = ReturnType<FormContract["serialize"]>;
